var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2211",
    d: "M0-682.665H22v22H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39346",
    "data-name": "Group 39346",
    transform: "translate(906 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2205",
    transform: "translate(-906 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2209",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2215",
    transform: "translate(0.645 3.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2217",
    d: "M-583.243,0h-18.133a1.289,1.289,0,0,0-1.289,1.289v11.6a1.289,1.289,0,0,0,1.289,1.289h18.133a1.289,1.289,0,0,0,1.289-1.289V1.289A1.289,1.289,0,0,0-583.243,0Z",
    transform: "translate(602.665)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2219",
    transform: "translate(4.512 7.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2221",
    d: "M-103.229-51.614a1.719,1.719,0,0,1-1.719,1.719,1.719,1.719,0,0,1-1.719-1.719,1.719,1.719,0,0,1,1.719-1.719A1.719,1.719,0,0,1-103.229-51.614Z",
    transform: "translate(106.666 53.333)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2223",
    transform: "translate(3.223 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2225",
    d: "M-90.325,0h0a3.008,3.008,0,0,0-3.008,3.008v.43h6.016v-.43A3.008,3.008,0,0,0-90.325,0Z",
    transform: "translate(93.333 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2227",
    transform: "translate(11.902 13.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2229",
    d: "M0,0H6.875",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2231",
    transform: "translate(11.902 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2233",
    d: "M0,0H6.875",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2235",
    transform: "translate(11.902 8.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2237",
    d: "M0,0H2.578",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.c4aa8c3dcea350abf72197e095132317.svg";
export { ForwardRef as ReactComponent };